// Tenant management for the Sunstone platform.
//
// This package defines the organizational hierarchy for multi-tenant SaaS
// administration. Tenants use a unified model where the same entity represents
// both partners (top-level) and customers (children of a partner), distinguished
// by the presence of a parent_id.
//
// Entity relationships:
//
//   Partner (Tenant, parent_id = "")
//     └── Customer (Tenant, parent_id = partner's ID)
//           └── User (belongs to exactly one tenant)
//
// Infrastructure concerns (cloud providers, clusters, workspaces, upgrades)
// are modeled separately in the deployments/v1 package. A single tenant may
// have multiple deployments across different cloud providers and regions.
//
// See also:
//   - deployments/v1/deployments.proto — cloud deployments and workspaces
//   - bootstrap/v1/bootstrap.proto     — infrastructure bootstrap callbacks
//
// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file tenants/v1/tenants.proto (package tenants.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_common } from "../../common/v1/common_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tenants/v1/tenants.proto.
 */
export const file_tenants_v1_tenants: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v1_common, file_google_protobuf_timestamp]);

/**
 * Tenant is the unified model for both partners and customers.
 *
 * The partner/customer distinction is encoded in a single field:
 *   - Partner:  parent_id is empty — this is a top-level tenant.
 *   - Customer: parent_id is set to the partner's tenant ID.
 *
 * This avoids separate Partner and Customer tables while preserving the
 * hierarchical relationship. A partner cannot be deleted if it has active
 * child customers.
 *
 * Infrastructure concerns (cloud providers, clusters, workspaces) are modeled
 * separately in the deployments/v1 package since a tenant may have
 * multiple deployments across different cloud providers and regions.
 *
 * @generated from message tenants.v1.Tenant
 */
export type Tenant = Message<"tenants.v1.Tenant"> & {
  /**
   * Unique tenant identifier.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Human-readable display name.
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * URL-friendly identifier used in URLs and as a customer-facing reference.
   * Constraints: max 11 characters, lowercase alphanumeric + hyphens,
   * DNS-compliant (RFC 1123), globally unique. Generated from display_name
   * at creation time.
   *
   * @generated from field: string slug = 3;
   */
  slug: string;

  /**
   * Parent partner ID. Empty for partners; set for customers.
   * When set, format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string parent_id = 4;
   */
  parentId: string;

  /**
   * Current activation status. See TenantStatus for semantics.
   *
   * @generated from field: tenants.v1.TenantStatus status = 5;
   */
  status: TenantStatus;

  /**
   * Cost center label for billing attribution.
   * Defaults to "Customer" for customer tenants.
   *
   * @generated from field: string cost_centre = 6;
   */
  costCentre: string;

  /**
   * User ID who last changed the status. Provides audit trail for
   * activation/deactivation events.
   *
   * @generated from field: string status_changed_by = 7;
   */
  statusChangedBy: string;

  /**
   * Timestamp of the last status change. Together with status_changed_by,
   * provides a compliance-ready audit trail.
   *
   * @generated from field: google.protobuf.Timestamp status_changed_at = 8;
   */
  statusChangedAt?: Timestamp;

  /**
   * External organization identifier (e.g. Auth0 org_id or other IdP
   * organization reference). May differ from the tenant id.
   *
   * @generated from field: string organization_id = 9;
   */
  organizationId: string;

  /**
   * Display name of the parent partner. Empty for partners (no parent).
   * Populated by ListTenants via a server-side join; not stored in the DB.
   *
   * @generated from field: string parent_name = 12;
   */
  parentName: string;

  /**
   * When the tenant record was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * When the tenant record was last updated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message tenants.v1.Tenant.
 * Use `create(TenantSchema)` to create a new message.
 */
export const TenantSchema: GenMessage<Tenant> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 0);

/**
 * User represents a person with access to the Sunstone admin portal
 * (Management Plane). Each user belongs to exactly one tenant and is
 * assigned one or more platform roles that control portal access.
 *
 * Authentication is handled externally. The user ID
 * corresponds to the identity provider's subject claim.
 *
 * @generated from message tenants.v1.User
 */
export type User = Message<"tenants.v1.User"> & {
  /**
   * Unique user identifier.
   * Format: user_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Email address. Must be unique system-wide.
   *
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * Display name.
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * The tenant this user belongs to (exactly one).
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string tenant_id = 5;
   */
  tenantId: string;

  /**
   * When the user record was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * When the user record was last updated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * This user's primary role. Empty if they have none (access is entirely
   * via access_rules — a restricted-only member, e.g. a contractor).
   * Format: role_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string primary_role_id = 8;
   */
  primaryRoleId: string;

  /**
   * Display name of primary_role_id. Empty when primary_role_id is empty.
   * Populated by a join; not stored on this row.
   *
   * @generated from field: string primary_role_name = 9;
   */
  primaryRoleName: string;

  /**
   * Whether primary_role_id's role has grants_all — holds every permission.
   * Meaningless when primary_role_id is empty. Not exclusive to Admin/
   * Operator Admin: see primary_role_is_unrestricted for that.
   *
   * @generated from field: bool primary_role_grants_all = 10;
   */
  primaryRoleGrantsAll: boolean;

  /**
   * Number of access_rules rows tied to this user. Populated by a join;
   * cheap summary for list views that don't need the full rule list.
   *
   * @generated from field: int32 access_rule_count = 11;
   */
  accessRuleCount: number;

  /**
   * Identity provider kind ('auth0', 'okta', ...), or empty for a pending
   * invitation that has never logged in.
   *
   * @generated from field: string idp_kind = 12;
   */
  idpKind: string;

  /**
   * primary_role_id's permission list — meaningless (and left empty) when
   * primary_role_grants_all is true, since grants_all already means every
   * permission. Populated only on GetCurrentUser (the caller's own record):
   * this is what the frontend's permission-aware nav/button gating reads,
   * computed server-side from the same rbac.EffectiveRole every enforcement
   * check already uses, rather than the frontend re-deriving it. Never
   * populated on another user's row (GetUser/ListUsers) — nothing there
   * needs to know a peer's permissions, and access_rules on top of a
   * primary role make a flat list misleading for anyone but the caller
   * themselves anyway.
   *
   * @generated from field: repeated string effective_permissions = 13;
   */
  effectivePermissions: string[];

  /**
   * The last time this user made an authenticated request. Unset for a
   * pending invitation that has never logged in.
   *
   * @generated from field: google.protobuf.Timestamp last_active_at = 14;
   */
  lastActiveAt?: Timestamp;

  /**
   * Whether primary_role_id is Admin or Operator Admin specifically —
   * bypasses access_rules entirely, holds manage access, and is permanently
   * immutable. Meaningless when primary_role_id is empty. Independent of
   * primary_role_grants_all.
   *
   * @generated from field: bool primary_role_is_unrestricted = 15;
   */
  primaryRoleIsUnrestricted: boolean;

  /**
   * Account lifecycle state. See UserStatus.
   *
   * @generated from field: tenants.v1.UserStatus status = 16;
   */
  status: UserStatus;
};

/**
 * Describes the message tenants.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 1);

/**
 * CreateTenantRequest creates a new partner or customer tenant.
 * To create a partner, leave parent_id empty.
 * To create a customer, set parent_id to the partner's tenant ID.
 *
 * @generated from message tenants.v1.CreateTenantRequest
 */
export type CreateTenantRequest = Message<"tenants.v1.CreateTenantRequest"> & {
  /**
   * Display name for the new tenant.
   *
   * @generated from field: string display_name = 1;
   */
  displayName: string;

  /**
   * URL-friendly slug. Must be globally unique, max 11 characters,
   * lowercase alphanumeric + hyphens, DNS-compliant.
   *
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * Parent partner ID. Leave empty to create a partner; set to a valid
   * tenant ID to create a customer under that partner.
   *
   * @generated from field: string parent_id = 3;
   */
  parentId: string;

  /**
   * Cost center label. Defaults to "Customer" for customer tenants
   * if not provided.
   *
   * @generated from field: string cost_centre = 4;
   */
  costCentre: string;

  /**
   * External organization identifier (e.g. from an IdP).
   *
   * @generated from field: string organization_id = 5;
   */
  organizationId: string;
};

/**
 * Describes the message tenants.v1.CreateTenantRequest.
 * Use `create(CreateTenantRequestSchema)` to create a new message.
 */
export const CreateTenantRequestSchema: GenMessage<CreateTenantRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 2);

/**
 * @generated from message tenants.v1.CreateTenantResponse
 */
export type CreateTenantResponse = Message<"tenants.v1.CreateTenantResponse"> & {
  /**
   * The newly created tenant, including server-generated fields
   * (id, status, timestamps).
   *
   * @generated from field: tenants.v1.Tenant tenant = 1;
   */
  tenant?: Tenant;
};

/**
 * Describes the message tenants.v1.CreateTenantResponse.
 * Use `create(CreateTenantResponseSchema)` to create a new message.
 */
export const CreateTenantResponseSchema: GenMessage<CreateTenantResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 3);

/**
 * @generated from message tenants.v1.GetTenantRequest
 */
export type GetTenantRequest = Message<"tenants.v1.GetTenantRequest"> & {
  /**
   * The tenant ID to retrieve.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message tenants.v1.GetTenantRequest.
 * Use `create(GetTenantRequestSchema)` to create a new message.
 */
export const GetTenantRequestSchema: GenMessage<GetTenantRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 4);

/**
 * @generated from message tenants.v1.GetTenantResponse
 */
export type GetTenantResponse = Message<"tenants.v1.GetTenantResponse"> & {
  /**
   * @generated from field: tenants.v1.Tenant tenant = 1;
   */
  tenant?: Tenant;
};

/**
 * Describes the message tenants.v1.GetTenantResponse.
 * Use `create(GetTenantResponseSchema)` to create a new message.
 */
export const GetTenantResponseSchema: GenMessage<GetTenantResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 5);

/**
 * ListTenantsRequest returns tenants with optional filtering.
 * When parent_id is empty, returns ALL tenants (both partners and customers).
 * When parent_id is set, returns only child tenants under that partner.
 *
 * @generated from message tenants.v1.ListTenantsRequest
 */
export type ListTenantsRequest = Message<"tenants.v1.ListTenantsRequest"> & {
  /**
   * Filter by parent partner ID. If empty, returns all tenants (both partners
   * and customers). If set, returns only customer tenants under that partner.
   *
   * @generated from field: string parent_id = 1;
   */
  parentId: string;

  /**
   * Maximum number of results to return. Server may return fewer.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * Pagination token from a previous ListTenantsResponse.
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;

  /**
   * Search across display_name and slug. Empty means no search filter.
   *
   * @generated from field: string search = 4;
   */
  search: string;

  /**
   * Filter by status. UNSPECIFIED means no status filter.
   *
   * @generated from field: tenants.v1.TenantStatus status_filter = 5;
   */
  statusFilter: TenantStatus;

  /**
   * Filter by type: "partner" (no parent), "customer" (has parent), or "" for all.
   *
   * @generated from field: string type_filter = 6;
   */
  typeFilter: string;

  /**
   * 1-indexed page number. 0 or 1 means the first page.
   *
   * @generated from field: int32 page = 7;
   */
  page: number;
};

/**
 * Describes the message tenants.v1.ListTenantsRequest.
 * Use `create(ListTenantsRequestSchema)` to create a new message.
 */
export const ListTenantsRequestSchema: GenMessage<ListTenantsRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 6);

/**
 * @generated from message tenants.v1.ListTenantsResponse
 */
export type ListTenantsResponse = Message<"tenants.v1.ListTenantsResponse"> & {
  /**
   * @generated from field: repeated tenants.v1.Tenant tenants = 1;
   */
  tenants: Tenant[];

  /**
   * Token for the next page of results. Empty if no more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * Total number of tenants matching the current search/filter.
   *
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message tenants.v1.ListTenantsResponse.
 * Use `create(ListTenantsResponseSchema)` to create a new message.
 */
export const ListTenantsResponseSchema: GenMessage<ListTenantsResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 7);

/**
 * UpdateTenantRequest updates mutable fields (name, slug) of a tenant.
 * The server records the caller's identity via audit logs.
 *
 * @generated from message tenants.v1.UpdateTenantRequest
 */
export type UpdateTenantRequest = Message<"tenants.v1.UpdateTenantRequest"> & {
  /**
   * The tenant to update.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * New human-readable display name.
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * New URL-friendly identifier. Constraints: max 11 characters,
   * lowercase alphanumeric + hyphens, DNS-compliant, globally unique.
   *
   * @generated from field: string slug = 3;
   */
  slug: string;
};

/**
 * Describes the message tenants.v1.UpdateTenantRequest.
 * Use `create(UpdateTenantRequestSchema)` to create a new message.
 */
export const UpdateTenantRequestSchema: GenMessage<UpdateTenantRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 8);

/**
 * @generated from message tenants.v1.UpdateTenantResponse
 */
export type UpdateTenantResponse = Message<"tenants.v1.UpdateTenantResponse"> & {
  /**
   * The updated tenant.
   *
   * @generated from field: tenants.v1.Tenant tenant = 1;
   */
  tenant?: Tenant;
};

/**
 * Describes the message tenants.v1.UpdateTenantResponse.
 * Use `create(UpdateTenantResponseSchema)` to create a new message.
 */
export const UpdateTenantResponseSchema: GenMessage<UpdateTenantResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 9);

/**
 * UpdateTenantStatusRequest activates or deactivates a tenant.
 * This is a dedicated RPC (rather than a generic update) because status
 * changes have audit implications — the server records who made the change
 * and when via status_changed_by and status_changed_at.
 *
 * @generated from message tenants.v1.UpdateTenantStatusRequest
 */
export type UpdateTenantStatusRequest = Message<"tenants.v1.UpdateTenantStatusRequest"> & {
  /**
   * The tenant to update.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * New status. Must be ACTIVE or INACTIVE.
   *
   * @generated from field: tenants.v1.TenantStatus status = 2;
   */
  status: TenantStatus;
};

/**
 * Describes the message tenants.v1.UpdateTenantStatusRequest.
 * Use `create(UpdateTenantStatusRequestSchema)` to create a new message.
 */
export const UpdateTenantStatusRequestSchema: GenMessage<UpdateTenantStatusRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 10);

/**
 * @generated from message tenants.v1.UpdateTenantStatusResponse
 */
export type UpdateTenantStatusResponse = Message<"tenants.v1.UpdateTenantStatusResponse"> & {
  /**
   * The updated tenant with new status and audit fields populated.
   *
   * @generated from field: tenants.v1.Tenant tenant = 1;
   */
  tenant?: Tenant;
};

/**
 * Describes the message tenants.v1.UpdateTenantStatusResponse.
 * Use `create(UpdateTenantStatusResponseSchema)` to create a new message.
 */
export const UpdateTenantStatusResponseSchema: GenMessage<UpdateTenantStatusResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 11);

/**
 * @generated from message tenants.v1.DeleteTenantRequest
 */
export type DeleteTenantRequest = Message<"tenants.v1.DeleteTenantRequest"> & {
  /**
   * The tenant to delete. This performs a soft-delete by setting the
   * tenant status to INACTIVE. Data is retained and reactivation
   * is possible via UpdateTenantStatus.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message tenants.v1.DeleteTenantRequest.
 * Use `create(DeleteTenantRequestSchema)` to create a new message.
 */
export const DeleteTenantRequestSchema: GenMessage<DeleteTenantRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 12);

/**
 * @generated from message tenants.v1.DeleteTenantResponse
 */
export type DeleteTenantResponse = Message<"tenants.v1.DeleteTenantResponse"> & {
};

/**
 * Describes the message tenants.v1.DeleteTenantResponse.
 * Use `create(DeleteTenantResponseSchema)` to create a new message.
 */
export const DeleteTenantResponseSchema: GenMessage<DeleteTenantResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 13);

/**
 * BlockingResource represents a child resource that must be deleted before
 * its parent can be deleted.
 *
 * @generated from message tenants.v1.BlockingResource
 */
export type BlockingResource = Message<"tenants.v1.BlockingResource"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * resource_type is one of: "workspace", "deployment", "tenant".
   *
   * @generated from field: string resource_type = 3;
   */
  resourceType: string;
};

/**
 * Describes the message tenants.v1.BlockingResource.
 * Use `create(BlockingResourceSchema)` to create a new message.
 */
export const BlockingResourceSchema: GenMessage<BlockingResource> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 14);

/**
 * @generated from message tenants.v1.CheckTenantDeleteBlockersRequest
 */
export type CheckTenantDeleteBlockersRequest = Message<"tenants.v1.CheckTenantDeleteBlockersRequest"> & {
  /**
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;
};

/**
 * Describes the message tenants.v1.CheckTenantDeleteBlockersRequest.
 * Use `create(CheckTenantDeleteBlockersRequestSchema)` to create a new message.
 */
export const CheckTenantDeleteBlockersRequestSchema: GenMessage<CheckTenantDeleteBlockersRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 15);

/**
 * @generated from message tenants.v1.CheckTenantDeleteBlockersResponse
 */
export type CheckTenantDeleteBlockersResponse = Message<"tenants.v1.CheckTenantDeleteBlockersResponse"> & {
  /**
   * For partners: active child tenants that must be deleted first.
   * For customers: active deployments that must be deleted first.
   * An empty list means deletion is allowed.
   *
   * @generated from field: repeated tenants.v1.BlockingResource blocking_resources = 1;
   */
  blockingResources: BlockingResource[];
};

/**
 * Describes the message tenants.v1.CheckTenantDeleteBlockersResponse.
 * Use `create(CheckTenantDeleteBlockersResponseSchema)` to create a new message.
 */
export const CheckTenantDeleteBlockersResponseSchema: GenMessage<CheckTenantDeleteBlockersResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 16);

/**
 * AccessRuleInput is a self-contained, additive grant or restriction layered
 * on top of an invitee's primary role. Never references a role — see
 * notes/SUN-408-workspace-level-rbac.md §4.
 *
 * @generated from message tenants.v1.AccessRuleInput
 */
export type AccessRuleInput = Message<"tenants.v1.AccessRuleInput"> & {
  /**
   * "allow" or "deny". Defaults to "allow" when omitted. An invitation may
   * create either kind of row directly, on top of the invitee's primary
   * role.
   *
   * @generated from field: string effect = 1;
   */
  effect: string;

  /**
   * "id_based" or "rule_based".
   *
   * @generated from field: string restriction_kind = 2;
   */
  restrictionKind: string;

  /**
   * id_based: typed-ID strings of any kind (e.g. "workspace_...", "deploy_...").
   *
   * @generated from field: repeated string resource_ids = 3;
   */
  resourceIds: string[];

  /**
   * rule_based: a JSON-encoded condition, e.g. [{"attribute":"environment","op":"eq","value":"prod"}].
   * Attributes are validated against pkg/go/rbac's RestrictableAttributes.
   *
   * @generated from field: string rule_condition_json = 4;
   */
  ruleConditionJson: string;

  /**
   * "deployment" or "workspace" — which resource kind this row scopes.
   * Required.
   *
   * @generated from field: string resource_kind = 5;
   */
  resourceKind: string;
};

/**
 * Describes the message tenants.v1.AccessRuleInput.
 * Use `create(AccessRuleInputSchema)` to create a new message.
 */
export const AccessRuleInputSchema: GenMessage<AccessRuleInput> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 17);

/**
 * CreateInvitationRequest invites a new user into the platform: a tenant
 * member (role_id + tenant_id) or a platform-wide member (role_id only, no
 * tenant_id — for Admin, caller must already be a platform admin; for a
 * Platform role, caller must already be a platform admin too).
 *
 * @generated from message tenants.v1.CreateInvitationRequest
 */
export type CreateInvitationRequest = Message<"tenants.v1.CreateInvitationRequest"> & {
  /**
   * Email address of the invitee.
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * The role to assign as this user's primary role. Required.
   * Format: role_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string role_id = 2;
   */
  roleId: string;

  /**
   * Tenant this user belongs to. Required unless role_id is the Operator
   * Admin system role, in which case it must be empty.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * Additional grants/restrictions layered on top of the primary role.
   *
   * @generated from field: repeated tenants.v1.AccessRuleInput access_rules = 4;
   */
  accessRules: AccessRuleInput[];

  /**
   * Display name for the invitee. Optional — if left empty, the identity
   * provider's own name claim fills it in on their first login.
   *
   * @generated from field: string name = 5;
   */
  name: string;
};

/**
 * Describes the message tenants.v1.CreateInvitationRequest.
 * Use `create(CreateInvitationRequestSchema)` to create a new message.
 */
export const CreateInvitationRequestSchema: GenMessage<CreateInvitationRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 18);

/**
 * @generated from message tenants.v1.CreateInvitationResponse
 */
export type CreateInvitationResponse = Message<"tenants.v1.CreateInvitationResponse"> & {
  /**
   * The newly created (pending) user's ID.
   * Format: user_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message tenants.v1.CreateInvitationResponse.
 * Use `create(CreateInvitationResponseSchema)` to create a new message.
 */
export const CreateInvitationResponseSchema: GenMessage<CreateInvitationResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 19);

/**
 * ResendInvitationRequest re-issues an expired or lost invitation email.
 * Only valid while the invitation is still pending (the user has never
 * logged in).
 *
 * @generated from message tenants.v1.ResendInvitationRequest
 */
export type ResendInvitationRequest = Message<"tenants.v1.ResendInvitationRequest"> & {
  /**
   * Format: user_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message tenants.v1.ResendInvitationRequest.
 * Use `create(ResendInvitationRequestSchema)` to create a new message.
 */
export const ResendInvitationRequestSchema: GenMessage<ResendInvitationRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 20);

/**
 * @generated from message tenants.v1.ResendInvitationResponse
 */
export type ResendInvitationResponse = Message<"tenants.v1.ResendInvitationResponse"> & {
};

/**
 * Describes the message tenants.v1.ResendInvitationResponse.
 * Use `create(ResendInvitationResponseSchema)` to create a new message.
 */
export const ResendInvitationResponseSchema: GenMessage<ResendInvitationResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 21);

/**
 * RevokeInvitationRequest cancels a pending invitation, deleting the user
 * row (and any access_rules, cascaded) and revoking the Auth0 invitation.
 * Only valid while the invitation is still pending.
 *
 * @generated from message tenants.v1.RevokeInvitationRequest
 */
export type RevokeInvitationRequest = Message<"tenants.v1.RevokeInvitationRequest"> & {
  /**
   * Format: user_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message tenants.v1.RevokeInvitationRequest.
 * Use `create(RevokeInvitationRequestSchema)` to create a new message.
 */
export const RevokeInvitationRequestSchema: GenMessage<RevokeInvitationRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 22);

/**
 * @generated from message tenants.v1.RevokeInvitationResponse
 */
export type RevokeInvitationResponse = Message<"tenants.v1.RevokeInvitationResponse"> & {
};

/**
 * Describes the message tenants.v1.RevokeInvitationResponse.
 * Use `create(RevokeInvitationResponseSchema)` to create a new message.
 */
export const RevokeInvitationResponseSchema: GenMessage<RevokeInvitationResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 23);

/**
 * @generated from message tenants.v1.GetUserRequest
 */
export type GetUserRequest = Message<"tenants.v1.GetUserRequest"> & {
  /**
   * The user ID to retrieve.
   * Format: user_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message tenants.v1.GetUserRequest.
 * Use `create(GetUserRequestSchema)` to create a new message.
 */
export const GetUserRequestSchema: GenMessage<GetUserRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 24);

/**
 * @generated from message tenants.v1.GetUserResponse
 */
export type GetUserResponse = Message<"tenants.v1.GetUserResponse"> & {
  /**
   * @generated from field: tenants.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message tenants.v1.GetUserResponse.
 * Use `create(GetUserResponseSchema)` to create a new message.
 */
export const GetUserResponseSchema: GenMessage<GetUserResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 25);

/**
 * GetCurrentUserRequest has no fields — the caller is identified by their
 * authenticated identity (JWT email), not a request parameter.
 *
 * @generated from message tenants.v1.GetCurrentUserRequest
 */
export type GetCurrentUserRequest = Message<"tenants.v1.GetCurrentUserRequest"> & {
};

/**
 * Describes the message tenants.v1.GetCurrentUserRequest.
 * Use `create(GetCurrentUserRequestSchema)` to create a new message.
 */
export const GetCurrentUserRequestSchema: GenMessage<GetCurrentUserRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 26);

/**
 * @generated from message tenants.v1.GetCurrentUserResponse
 */
export type GetCurrentUserResponse = Message<"tenants.v1.GetCurrentUserResponse"> & {
  /**
   * @generated from field: tenants.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message tenants.v1.GetCurrentUserResponse.
 * Use `create(GetCurrentUserResponseSchema)` to create a new message.
 */
export const GetCurrentUserResponseSchema: GenMessage<GetCurrentUserResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 27);

/**
 * ListUsersRequest returns users within a specific tenant.
 * The tenant_id filter is required — users cannot be listed across tenants.
 *
 * @generated from message tenants.v1.ListUsersRequest
 */
export type ListUsersRequest = Message<"tenants.v1.ListUsersRequest"> & {
  /**
   * Filter by tenant ID. Required.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * Maximum number of results to return. Server may return fewer.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * Pagination token from a previous ListUsersResponse.
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;

  /**
   * Search across name and email. Empty means no search filter.
   *
   * @generated from field: string search = 4;
   */
  search: string;

  /**
   * Filter by primary role ID. Empty string means no role filter.
   * Format: role_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string role_id_filter = 5;
   */
  roleIdFilter: string;

  /**
   * 1-indexed page number. 0 or 1 means the first page.
   *
   * @generated from field: int32 page = 6;
   */
  page: number;

  /**
   * Deprecated: use status_filter with USER_STATUS_INVITED instead. If true
   * (and status_filter is unset), only rows with no idp_kind (never logged
   * in — a pending invitation). tenant_id is still required alongside this.
   *
   * @generated from field: bool pending_only = 7 [deprecated = true];
   * @deprecated
   */
  pendingOnly: boolean;

  /**
   * If true, list platform-wide (tenant-less) Admin rows instead of a
   * tenant's members. When set, tenant_id must be empty and the caller must
   * already be a platform admin.
   *
   * @generated from field: bool platform_admins_only = 8;
   */
  platformAdminsOnly: boolean;

  /**
   * "name" or "last_active". Empty defaults to "name".
   *
   * @generated from field: string sort_by = 9;
   */
  sortBy: string;

  /**
   * "asc" or "desc". Empty defaults to "asc".
   *
   * @generated from field: string sort_dir = 10;
   */
  sortDir: string;

  /**
   * Filter by account status. UNSPECIFIED (the default) means every status
   * except DELETED — a deleted account is only returned when this is set
   * explicitly to USER_STATUS_DELETED.
   *
   * @generated from field: tenants.v1.UserStatus status_filter = 11;
   */
  statusFilter: UserStatus;
};

/**
 * Describes the message tenants.v1.ListUsersRequest.
 * Use `create(ListUsersRequestSchema)` to create a new message.
 */
export const ListUsersRequestSchema: GenMessage<ListUsersRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 28);

/**
 * @generated from message tenants.v1.ListUsersResponse
 */
export type ListUsersResponse = Message<"tenants.v1.ListUsersResponse"> & {
  /**
   * @generated from field: repeated tenants.v1.User users = 1;
   */
  users: User[];

  /**
   * Token for the next page of results. Empty if no more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * Total number of users matching the current search/filter.
   *
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message tenants.v1.ListUsersResponse.
 * Use `create(ListUsersResponseSchema)` to create a new message.
 */
export const ListUsersResponseSchema: GenMessage<ListUsersResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 29);

/**
 * UpdateUserStatusRequest activates or deactivates a user account.
 * This is a dedicated RPC (rather than a generic update) because status
 * changes have audit implications — the server records the change as a
 * dedicated audit event (user.disabled / user.enabled).
 *
 * @generated from message tenants.v1.UpdateUserStatusRequest
 */
export type UpdateUserStatusRequest = Message<"tenants.v1.UpdateUserStatusRequest"> & {
  /**
   * The user to update.
   * Format: user_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * New status. Must be ACTIVE or DISABLED.
   *
   * @generated from field: tenants.v1.UserStatus status = 2;
   */
  status: UserStatus;
};

/**
 * Describes the message tenants.v1.UpdateUserStatusRequest.
 * Use `create(UpdateUserStatusRequestSchema)` to create a new message.
 */
export const UpdateUserStatusRequestSchema: GenMessage<UpdateUserStatusRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 30);

/**
 * @generated from message tenants.v1.UpdateUserStatusResponse
 */
export type UpdateUserStatusResponse = Message<"tenants.v1.UpdateUserStatusResponse"> & {
  /**
   * The updated user with new status populated.
   *
   * @generated from field: tenants.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message tenants.v1.UpdateUserStatusResponse.
 * Use `create(UpdateUserStatusResponseSchema)` to create a new message.
 */
export const UpdateUserStatusResponseSchema: GenMessage<UpdateUserStatusResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 31);

/**
 * @generated from message tenants.v1.DeleteUserRequest
 */
export type DeleteUserRequest = Message<"tenants.v1.DeleteUserRequest"> & {
  /**
   * The user to delete. The account must already be DISABLED (see
   * UpdateUserStatus) — this is a two-step, deliberate operation. Performs
   * a soft-delete in Sunstone (status becomes DELETED, data retained for
   * audit history) and a hard-delete of the user's Auth0 identity, if any.
   * Terminal — there is no undelete.
   * Format: user_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message tenants.v1.DeleteUserRequest.
 * Use `create(DeleteUserRequestSchema)` to create a new message.
 */
export const DeleteUserRequestSchema: GenMessage<DeleteUserRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 32);

/**
 * @generated from message tenants.v1.DeleteUserResponse
 */
export type DeleteUserResponse = Message<"tenants.v1.DeleteUserResponse"> & {
  /**
   * Non-empty when the Sunstone-side delete succeeded but a non-fatal
   * follow-up step failed — currently only "removed from Auth0 failed."
   * The delete itself is NOT rolled back when this is set: the account is
   * gone, this is a heads-up about a secondary system, not an error.
   *
   * @generated from field: string warning = 1;
   */
  warning: string;
};

/**
 * Describes the message tenants.v1.DeleteUserResponse.
 * Use `create(DeleteUserResponseSchema)` to create a new message.
 */
export const DeleteUserResponseSchema: GenMessage<DeleteUserResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 33);

/**
 * AccessRule is a self-contained allow/deny grant tied to a user or a role
 * — see notes/SUN-408-workspace-level-rbac.md §4. Exactly one of
 * user_id/role_id is ever set.
 *
 * @generated from message tenants.v1.AccessRule
 */
export type AccessRule = Message<"tenants.v1.AccessRule"> & {
  /**
   * Format: rule_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Format: user_[20 lowercase alphanumeric characters]. Empty for a
   * role-owned row.
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * "allow" or "deny".
   *
   * @generated from field: string effect = 3;
   */
  effect: string;

  /**
   * "id_based" or "rule_based".
   *
   * @generated from field: string restriction_kind = 4;
   */
  restrictionKind: string;

  /**
   * id_based: typed-ID strings the rule applies to.
   *
   * @generated from field: repeated string resource_ids = 5;
   */
  resourceIds: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * Format: user_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string created_by = 7;
   */
  createdBy: string;

  /**
   * rule_based: the JSON-encoded condition, same shape as
   * AccessRuleInput.rule_condition_json. Empty when restriction_kind is
   * "id_based".
   *
   * @generated from field: string rule_condition_json = 8;
   */
  ruleConditionJson: string;

  /**
   * "deployment" or "workspace" — which resource kind this row scopes.
   *
   * @generated from field: string resource_kind = 9;
   */
  resourceKind: string;

  /**
   * Format: role_[20 lowercase alphanumeric characters]. Empty for a
   * user-owned row.
   *
   * @generated from field: string role_id = 10;
   */
  roleId: string;
};

/**
 * Describes the message tenants.v1.AccessRule.
 * Use `create(AccessRuleSchema)` to create a new message.
 */
export const AccessRuleSchema: GenMessage<AccessRule> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 34);

/**
 * ListAccessRulesRequest returns every access_rules row for one user.
 *
 * @generated from message tenants.v1.ListAccessRulesRequest
 */
export type ListAccessRulesRequest = Message<"tenants.v1.ListAccessRulesRequest"> & {
  /**
   * Format: user_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message tenants.v1.ListAccessRulesRequest.
 * Use `create(ListAccessRulesRequestSchema)` to create a new message.
 */
export const ListAccessRulesRequestSchema: GenMessage<ListAccessRulesRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 35);

/**
 * @generated from message tenants.v1.ListAccessRulesResponse
 */
export type ListAccessRulesResponse = Message<"tenants.v1.ListAccessRulesResponse"> & {
  /**
   * @generated from field: repeated tenants.v1.AccessRule rules = 1;
   */
  rules: AccessRule[];
};

/**
 * Describes the message tenants.v1.ListAccessRulesResponse.
 * Use `create(ListAccessRulesResponseSchema)` to create a new message.
 */
export const ListAccessRulesResponseSchema: GenMessage<ListAccessRulesResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 36);

/**
 * MatchedResource is one workspace/deployment a candidate restriction
 * currently applies to — the restriction builder's live-preview panel
 * (notes/SUN-408-phase5-frontend-ui.md's "signature moment").
 *
 * @generated from message tenants.v1.MatchedResource
 */
export type MatchedResource = Message<"tenants.v1.MatchedResource"> & {
  /**
   * Typed-ID string, e.g. "workspace_..." or "deploy_...".
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * "workspace" or "deployment".
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * The parent deployment ID, for a workspace-kind match only — empty for a
   * deployment-kind match. Lets a caller cross-reference this match against
   * its own deployment-kind restriction to tell whether the workspace is
   * actually reachable (this preview is gate-independent by design — it
   * shows every attribute match regardless of whether the deployment-kind
   * gate would also need to pass).
   *
   * @generated from field: string deployment_id = 4;
   */
  deploymentId: string;
};

/**
 * Describes the message tenants.v1.MatchedResource.
 * Use `create(MatchedResourceSchema)` to create a new message.
 */
export const MatchedResourceSchema: GenMessage<MatchedResource> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 37);

/**
 * PreviewAccessRuleMatchRequest evaluates a candidate restriction (not yet
 * saved) against the tenant's current workspaces/deployments, using the
 * exact same interpreter the enforcement path uses
 * (internal/management/services/v1/accessrule) — this is a read-only dry
 * run, not a new evaluation rule.
 *
 * @generated from message tenants.v1.PreviewAccessRuleMatchRequest
 */
export type PreviewAccessRuleMatchRequest = Message<"tenants.v1.PreviewAccessRuleMatchRequest"> & {
  /**
   * Tenant whose workspaces/deployments to match against.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * "id_based" or "rule_based".
   *
   * @generated from field: string restriction_kind = 2;
   */
  restrictionKind: string;

  /**
   * id_based: the candidate resource_ids — echoed back as matches after
   * confirming each one still exists and is visible to the tenant.
   *
   * @generated from field: repeated string resource_ids = 3;
   */
  resourceIds: string[];

  /**
   * rule_based: the candidate condition, same shape as
   * AccessRuleInput.rule_condition_json. Matched against both workspaces
   * and deployments — an attribute that doesn't apply to a given kind
   * simply never matches on that kind.
   *
   * @generated from field: string rule_condition_json = 4;
   */
  ruleConditionJson: string;
};

/**
 * Describes the message tenants.v1.PreviewAccessRuleMatchRequest.
 * Use `create(PreviewAccessRuleMatchRequestSchema)` to create a new message.
 */
export const PreviewAccessRuleMatchRequestSchema: GenMessage<PreviewAccessRuleMatchRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 38);

/**
 * @generated from message tenants.v1.PreviewAccessRuleMatchResponse
 */
export type PreviewAccessRuleMatchResponse = Message<"tenants.v1.PreviewAccessRuleMatchResponse"> & {
  /**
   * @generated from field: repeated tenants.v1.MatchedResource matching_resources = 1;
   */
  matchingResources: MatchedResource[];
};

/**
 * Describes the message tenants.v1.PreviewAccessRuleMatchResponse.
 * Use `create(PreviewAccessRuleMatchResponseSchema)` to create a new message.
 */
export const PreviewAccessRuleMatchResponseSchema: GenMessage<PreviewAccessRuleMatchResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 39);

/**
 * UpdateUserAccessRequest performs one or more of: renaming the user,
 * changing their primary role, creating new access_rules, and revoking
 * existing access_rules — all in a single server-side transaction, recorded
 * as one audit event (EventUserAccessUpdated) instead of one event per
 * sub-change. Supersedes the retired UpdateUserRole/UpdateUserName/
 * CreateAccessRule/RevokeAccessRule RPCs (notes/SUN-408-workspace-level-rbac.md
 * §8 covers role assignment only at invite time; this is the later,
 * deliberate edit). Admin/Operator Admin only — same authorization shape as
 * CreateInvitation. Every field below is optional; a save that changes
 * nothing is a no-op (no DB write, no audit event).
 *
 * @generated from message tenants.v1.UpdateUserAccessRequest
 */
export type UpdateUserAccessRequest = Message<"tenants.v1.UpdateUserAccessRequest"> & {
  /**
   * Format: user_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * The new display name. Absent means "don't change the name" — proto3
   * `optional` distinguishes that from an explicit empty string, which is
   * rejected (a name can't be cleared).
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * The new primary role. Absent means "don't change the role". An explicit
   * empty string clears primary_role_id back to NULL — only accepted when
   * the user already has (or this same request grants) at least one
   * access_rules row; a member with no role and no grants can never log in.
   * Format: role_[20 lowercase alphanumeric characters]
   *
   * @generated from field: optional string role_id = 3;
   */
  roleId?: string;

  /**
   * Additional grants/restrictions to create, layered on top of the primary
   * role. Empty means "create none".
   *
   * @generated from field: repeated tenants.v1.AccessRuleInput rules_to_create = 4;
   */
  rulesToCreate: AccessRuleInput[];

  /**
   * access_rules row IDs to delete. Empty means "revoke none".
   * Format: rule_[20 lowercase alphanumeric characters]
   *
   * @generated from field: repeated string rule_ids_to_revoke = 5;
   */
  ruleIdsToRevoke: string[];
};

/**
 * Describes the message tenants.v1.UpdateUserAccessRequest.
 * Use `create(UpdateUserAccessRequestSchema)` to create a new message.
 */
export const UpdateUserAccessRequestSchema: GenMessage<UpdateUserAccessRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 40);

/**
 * @generated from message tenants.v1.UpdateUserAccessResponse
 */
export type UpdateUserAccessResponse = Message<"tenants.v1.UpdateUserAccessResponse"> & {
  /**
   * @generated from field: tenants.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message tenants.v1.UpdateUserAccessResponse.
 * Use `create(UpdateUserAccessResponseSchema)` to create a new message.
 */
export const UpdateUserAccessResponseSchema: GenMessage<UpdateUserAccessResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 41);

/**
 * Role is a permission set plus scope — see
 * notes/SUN-408-workspace-level-rbac.md §2.
 *
 * @generated from message tenants.v1.Role
 */
export type Role = Message<"tenants.v1.Role"> & {
  /**
   * Format: role_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Empty for a System or Platform role. Set for a tenant's own Tenant role
   * (visible only to that tenant). See scope to distinguish System from
   * Platform when this is empty.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * Whether the role has every permission, including ones added after the
   * role was created — its permissions list is ignored and auto-updates
   * with every new platform permission. Not exclusive to Admin: any role
   * can have this set. Governs permissions only — it says nothing about
   * whether the role bypasses access_rules or has manage access; see
   * is_unrestricted for that.
   *
   * @generated from field: bool grants_all = 5;
   */
  grantsAll: boolean;

  /**
   * @generated from field: repeated string permissions = 6;
   */
  permissions: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;

  /**
   * True only for the one seeded Admin role. An unrestricted role bypasses
   * access_rules entirely, has manage access, and is permanently immutable
   * — independent of grants_all.
   *
   * @generated from field: bool is_unrestricted = 9;
   */
  isUnrestricted: boolean;

  /**
   * "system" (Admin — shared across every tenant), "tenant" (a tenant's own
   * custom role, tenant_id set), or "platform" (a custom role for
   * platform-wide/tenant-less users, tenant_id empty but NOT shared across
   * tenants).
   *
   * @generated from field: string scope = 10;
   */
  scope: string;
};

/**
 * Describes the message tenants.v1.Role.
 * Use `create(RoleSchema)` to create a new message.
 */
export const RoleSchema: GenMessage<Role> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 42);

/**
 * GetRoleRequest fetches one role by ID, for the role detail view.
 *
 * @generated from message tenants.v1.GetRoleRequest
 */
export type GetRoleRequest = Message<"tenants.v1.GetRoleRequest"> & {
  /**
   * Format: role_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message tenants.v1.GetRoleRequest.
 * Use `create(GetRoleRequestSchema)` to create a new message.
 */
export const GetRoleRequestSchema: GenMessage<GetRoleRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 43);

/**
 * @generated from message tenants.v1.GetRoleResponse
 */
export type GetRoleResponse = Message<"tenants.v1.GetRoleResponse"> & {
  /**
   * @generated from field: tenants.v1.Role role = 1;
   */
  role?: Role;
};

/**
 * Describes the message tenants.v1.GetRoleResponse.
 * Use `create(GetRoleResponseSchema)` to create a new message.
 */
export const GetRoleResponseSchema: GenMessage<GetRoleResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 44);

/**
 * ListRolesRequest returns the roles available to a tenant.
 *
 * @generated from message tenants.v1.ListRolesRequest
 */
export type ListRolesRequest = Message<"tenants.v1.ListRolesRequest"> & {
  /**
   * If empty, returns every "system"-scope row (Admin) plus every
   * "platform"-scope row — the platform-context view (System & Platform
   * Roles, and the role picker for a tenant-less user). If set, returns
   * Admin plus that one tenant's own "tenant"-scope rows.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * Maximum number of results to return. Server may return fewer.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * 1-indexed page number. 0 or 1 means the first page.
   *
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * Search across name. Empty means no search filter.
   *
   * @generated from field: string search = 4;
   */
  search: string;

  /**
   * "name" or "created_at". Empty defaults to "name".
   *
   * @generated from field: string sort_by = 5;
   */
  sortBy: string;

  /**
   * "asc" or "desc". Empty defaults to "asc".
   *
   * @generated from field: string sort_dir = 6;
   */
  sortDir: string;

  /**
   * "system", "tenant", or "platform" — see Role.scope. Empty means no
   * scope filter.
   *
   * @generated from field: string scope_filter = 7;
   */
  scopeFilter: string;

  /**
   * One of the 5 resource kinds (e.g. "workspace") — matches a role whose
   * permissions include at least one "*:<kind>" permission. Empty means no
   * filter.
   *
   * @generated from field: string resource_kind_filter = 8;
   */
  resourceKindFilter: string;
};

/**
 * Describes the message tenants.v1.ListRolesRequest.
 * Use `create(ListRolesRequestSchema)` to create a new message.
 */
export const ListRolesRequestSchema: GenMessage<ListRolesRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 45);

/**
 * @generated from message tenants.v1.ListRolesResponse
 */
export type ListRolesResponse = Message<"tenants.v1.ListRolesResponse"> & {
  /**
   * @generated from field: repeated tenants.v1.Role roles = 1;
   */
  roles: Role[];

  /**
   * Total number of roles matching tenant_id, across all pages.
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message tenants.v1.ListRolesResponse.
 * Use `create(ListRolesResponseSchema)` to create a new message.
 */
export const ListRolesResponseSchema: GenMessage<ListRolesResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 46);

/**
 * CreateRoleRequest creates a new role. If tenant_id is set, a Tenant role
 * scoped to that tenant. If empty, a Platform role — visible only in the
 * platform context, gated to a platform admin (a tenant-less Admin).
 * grants_all can be set by anyone with manage access, for any role — it
 * makes the role hold every permission but does not make it Admin: only the
 * one seeded role is ever unrestricted (bypasses access_rules, holds manage
 * access, immutable).
 *
 * @generated from message tenants.v1.CreateRoleRequest
 */
export type CreateRoleRequest = Message<"tenants.v1.CreateRoleRequest"> & {
  /**
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * Validated against pkg/go/rbac's AllPermissions.
   *
   * @generated from field: repeated string permissions = 4;
   */
  permissions: string[];

  /**
   * Whether the created role holds every permission. See Role.grants_all.
   *
   * @generated from field: bool grants_all = 5;
   */
  grantsAll: boolean;

  /**
   * The role's own initial access_rules, created in the same request/
   * transaction/audit event as the role itself. Empty means "create none".
   *
   * @generated from field: repeated tenants.v1.AccessRuleInput access_rules = 6;
   */
  accessRules: AccessRuleInput[];
};

/**
 * Describes the message tenants.v1.CreateRoleRequest.
 * Use `create(CreateRoleRequestSchema)` to create a new message.
 */
export const CreateRoleRequestSchema: GenMessage<CreateRoleRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 47);

/**
 * @generated from message tenants.v1.CreateRoleResponse
 */
export type CreateRoleResponse = Message<"tenants.v1.CreateRoleResponse"> & {
  /**
   * @generated from field: tenants.v1.Role role = 1;
   */
  role?: Role;
};

/**
 * Describes the message tenants.v1.CreateRoleResponse.
 * Use `create(CreateRoleResponseSchema)` to create a new message.
 */
export const CreateRoleResponseSchema: GenMessage<CreateRoleResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 48);

/**
 * UpdateRoleRequest edits an existing role's name/description/permissions/
 * grants_all, and optionally its own access_rules in the same request/
 * transaction/audit event — mirrors UpdateUserAccessRequest's
 * rules_to_create/rule_ids_to_revoke shape (Admin can never own access_rules
 * — see role/access.go's requireManageAccessToRole). Rejected outright if the
 * target role is Admin (is_unrestricted) — that role is permanently
 * un-editable. id/tenant_id/scope/is_unrestricted are immutable and
 * intentionally not request fields.
 *
 * @generated from message tenants.v1.UpdateRoleRequest
 */
export type UpdateRoleRequest = Message<"tenants.v1.UpdateRoleRequest"> & {
  /**
   * Format: role_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * Validated against pkg/go/rbac's AllPermissions.
   *
   * @generated from field: repeated string permissions = 4;
   */
  permissions: string[];

  /**
   * Whether the role holds every permission. See Role.grants_all.
   *
   * @generated from field: bool grants_all = 5;
   */
  grantsAll: boolean;

  /**
   * Additional grants/restrictions to create, layered on top of this role's
   * existing access_rules. Empty means "create none".
   *
   * @generated from field: repeated tenants.v1.AccessRuleInput rules_to_create = 6;
   */
  rulesToCreate: AccessRuleInput[];

  /**
   * access_rules row IDs to delete — must belong to this role. Empty means
   * "revoke none".
   * Format: rule_[20 lowercase alphanumeric characters]
   *
   * @generated from field: repeated string rule_ids_to_revoke = 7;
   */
  ruleIdsToRevoke: string[];
};

/**
 * Describes the message tenants.v1.UpdateRoleRequest.
 * Use `create(UpdateRoleRequestSchema)` to create a new message.
 */
export const UpdateRoleRequestSchema: GenMessage<UpdateRoleRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 49);

/**
 * @generated from message tenants.v1.UpdateRoleResponse
 */
export type UpdateRoleResponse = Message<"tenants.v1.UpdateRoleResponse"> & {
  /**
   * @generated from field: tenants.v1.Role role = 1;
   */
  role?: Role;
};

/**
 * Describes the message tenants.v1.UpdateRoleResponse.
 * Use `create(UpdateRoleResponseSchema)` to create a new message.
 */
export const UpdateRoleResponseSchema: GenMessage<UpdateRoleResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 50);

/**
 * ListRoleAccessRulesRequest returns every access_rules row owned by one
 * role.
 *
 * @generated from message tenants.v1.ListRoleAccessRulesRequest
 */
export type ListRoleAccessRulesRequest = Message<"tenants.v1.ListRoleAccessRulesRequest"> & {
  /**
   * Format: role_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string role_id = 1;
   */
  roleId: string;
};

/**
 * Describes the message tenants.v1.ListRoleAccessRulesRequest.
 * Use `create(ListRoleAccessRulesRequestSchema)` to create a new message.
 */
export const ListRoleAccessRulesRequestSchema: GenMessage<ListRoleAccessRulesRequest> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 51);

/**
 * @generated from message tenants.v1.ListRoleAccessRulesResponse
 */
export type ListRoleAccessRulesResponse = Message<"tenants.v1.ListRoleAccessRulesResponse"> & {
  /**
   * @generated from field: repeated tenants.v1.AccessRule access_rules = 1;
   */
  accessRules: AccessRule[];
};

/**
 * Describes the message tenants.v1.ListRoleAccessRulesResponse.
 * Use `create(ListRoleAccessRulesResponseSchema)` to create a new message.
 */
export const ListRoleAccessRulesResponseSchema: GenMessage<ListRoleAccessRulesResponse> = /*@__PURE__*/
  messageDesc(file_tenants_v1_tenants, 52);

/**
 * TenantStatus represents the activation state of a tenant.
 * Deactivation is a soft-delete — the tenant's data is retained and
 * reactivation is possible. Status changes are audited via the
 * status_changed_by and status_changed_at fields on the Tenant message.
 *
 * @generated from enum tenants.v1.TenantStatus
 */
export enum TenantStatus {
  /**
   * @generated from enum value: TENANT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Tenant is active and operational.
   *
   * @generated from enum value: TENANT_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * Tenant is deactivated. Data is retained; reactivation is possible.
   *
   * @generated from enum value: TENANT_STATUS_INACTIVE = 2;
   */
  INACTIVE = 2,
}

/**
 * Describes the enum tenants.v1.TenantStatus.
 */
export const TenantStatusSchema: GenEnum<TenantStatus> = /*@__PURE__*/
  enumDesc(file_tenants_v1_tenants, 0);

/**
 * UserStatus represents a user account's lifecycle state.
 * invited -> active -> disabled -> deleted. Disabling is a soft, reversible
 * app-side-only block on access (see UpdateUserStatus). Deleting is a
 * terminal soft-delete in Sunstone paired with a hard-delete of the user's
 * Auth0 identity (see DeleteUser) — there is no path back from DELETED.
 *
 * @generated from enum tenants.v1.UserStatus
 */
export enum UserStatus {
  /**
   * @generated from enum value: USER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Invited but has never logged in yet.
   *
   * @generated from enum value: USER_STATUS_INVITED = 1;
   */
  INVITED = 1,

  /**
   * Has logged in at least once and can authenticate normally.
   *
   * @generated from enum value: USER_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * Blocked from authenticating. Reversible via UpdateUserStatus.
   *
   * @generated from enum value: USER_STATUS_DISABLED = 3;
   */
  DISABLED = 3,

  /**
   * Permanently deleted (soft-delete in Sunstone, hard-delete in Auth0).
   * Terminal — never reversible.
   *
   * @generated from enum value: USER_STATUS_DELETED = 4;
   */
  DELETED = 4,
}

/**
 * Describes the enum tenants.v1.UserStatus.
 */
export const UserStatusSchema: GenEnum<UserStatus> = /*@__PURE__*/
  enumDesc(file_tenants_v1_tenants, 1);

/**
 * TenantService manages the lifecycle of partners and customer tenants.
 *
 * Partners are top-level tenants that own customer tenants. Customers are
 * child tenants scoped to a partner. Both use the same Tenant entity,
 * differentiated by the parent_id field.
 *
 * Status changes (activation/deactivation) are audited. Deletion is a
 * soft-delete that deactivates the tenant while retaining data.
 *
 * @generated from service tenants.v1.TenantService
 */
export const TenantService: GenService<{
  /**
   * CreateTenant creates a new partner or customer tenant.
   * Partners are created with an empty parent_id; customers are created
   * with parent_id set to their partner's tenant ID.
   *
   * @generated from rpc tenants.v1.TenantService.CreateTenant
   */
  createTenant: {
    methodKind: "unary";
    input: typeof CreateTenantRequestSchema;
    output: typeof CreateTenantResponseSchema;
  },
  /**
   * GetTenant retrieves a single tenant by ID.
   *
   * @generated from rpc tenants.v1.TenantService.GetTenant
   */
  getTenant: {
    methodKind: "unary";
    input: typeof GetTenantRequestSchema;
    output: typeof GetTenantResponseSchema;
  },
  /**
   * ListTenants returns tenants, optionally filtered by parent.
   * With no parent_id filter, returns all tenants (both partners and customers).
   * With a parent_id filter, returns only customer tenants under that partner.
   *
   * @generated from rpc tenants.v1.TenantService.ListTenants
   */
  listTenants: {
    methodKind: "unary";
    input: typeof ListTenantsRequestSchema;
    output: typeof ListTenantsResponseSchema;
  },
  /**
   * UpdateTenant updates a tenant's mutable fields, such as display_name and slug.
   * The server records the change for audit purposes.
   *
   * @generated from rpc tenants.v1.TenantService.UpdateTenant
   */
  updateTenant: {
    methodKind: "unary";
    input: typeof UpdateTenantRequestSchema;
    output: typeof UpdateTenantResponseSchema;
  },
  /**
   * UpdateTenantStatus activates or deactivates a tenant. The server
   * records the caller's identity and timestamp for audit purposes.
   *
   * @generated from rpc tenants.v1.TenantService.UpdateTenantStatus
   */
  updateTenantStatus: {
    methodKind: "unary";
    input: typeof UpdateTenantStatusRequestSchema;
    output: typeof UpdateTenantStatusResponseSchema;
  },
  /**
   * DeleteTenant soft-deletes a tenant by setting its status to INACTIVE.
   * A partner cannot be deleted if it has active child customers.
   *
   * @generated from rpc tenants.v1.TenantService.DeleteTenant
   */
  deleteTenant: {
    methodKind: "unary";
    input: typeof DeleteTenantRequestSchema;
    output: typeof DeleteTenantResponseSchema;
  },
  /**
   * CheckTenantDeleteBlockers returns child resources that block deletion.
   * For partners, returns active child tenants. For customers, returns active
   * deployments. An empty list means deletion is allowed.
   *
   * @generated from rpc tenants.v1.TenantService.CheckTenantDeleteBlockers
   */
  checkTenantDeleteBlockers: {
    methodKind: "unary";
    input: typeof CheckTenantDeleteBlockersRequestSchema;
    output: typeof CheckTenantDeleteBlockersResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tenants_v1_tenants, 0);

/**
 * UserService manages admin portal user accounts within tenants.
 *
 * Each user belongs to exactly one tenant (or no tenant, for a platform-wide
 * Operator Admin) and is provisioned via invitation: an Admin or Operator
 * Admin invites an email address with a primary role and, optionally,
 * additional access_rules grants/restrictions. Authentication is delegated
 * to an external identity provider (e.g. Auth0).
 *
 * @generated from service tenants.v1.UserService
 */
export const UserService: GenService<{
  /**
   * CreateInvitation invites a new user, creating their row eagerly and
   * sending an Auth0 Organization Invitation email.
   *
   * @generated from rpc tenants.v1.UserService.CreateInvitation
   */
  createInvitation: {
    methodKind: "unary";
    input: typeof CreateInvitationRequestSchema;
    output: typeof CreateInvitationResponseSchema;
  },
  /**
   * ResendInvitation re-issues the invitation email for a still-pending
   * invitee (one who has never logged in).
   *
   * @generated from rpc tenants.v1.UserService.ResendInvitation
   */
  resendInvitation: {
    methodKind: "unary";
    input: typeof ResendInvitationRequestSchema;
    output: typeof ResendInvitationResponseSchema;
  },
  /**
   * RevokeInvitation cancels a still-pending invitation.
   *
   * @generated from rpc tenants.v1.UserService.RevokeInvitation
   */
  revokeInvitation: {
    methodKind: "unary";
    input: typeof RevokeInvitationRequestSchema;
    output: typeof RevokeInvitationResponseSchema;
  },
  /**
   * GetUser retrieves a user by ID.
   *
   * @generated from rpc tenants.v1.UserService.GetUser
   */
  getUser: {
    methodKind: "unary";
    input: typeof GetUserRequestSchema;
    output: typeof GetUserResponseSchema;
  },
  /**
   * GetCurrentUser retrieves the DB-authoritative record for the calling
   * user (resolved by email, like the other caller-identity lookups in this
   * service). Returns NotFound if the caller has no sunstone.users row yet —
   * the frontend's signal to show an access-denied state rather than an
   * empty one. Returns FailedPrecondition if the account exists but is
   * DISABLED or DELETED — a distinct signal from NotFound so the frontend
   * can show an account-disabled state instead of the generic one.
   *
   * @generated from rpc tenants.v1.UserService.GetCurrentUser
   */
  getCurrentUser: {
    methodKind: "unary";
    input: typeof GetCurrentUserRequestSchema;
    output: typeof GetCurrentUserResponseSchema;
  },
  /**
   * ListUsers returns users for a given tenant, or (with
   * platform_admins_only) the platform's tenant-less Admins. Exactly one of
   * tenant_id or platform_admins_only applies on any given call.
   *
   * @generated from rpc tenants.v1.UserService.ListUsers
   */
  listUsers: {
    methodKind: "unary";
    input: typeof ListUsersRequestSchema;
    output: typeof ListUsersResponseSchema;
  },
  /**
   * UpdateUserStatus enables or disables a user account. Disabling blocks
   * the account from authenticating starting with its next request —
   * enforced app-side only, never touches Auth0. Rejects disabling the
   * caller's own account or a tenant's last remaining Admin.
   *
   * @generated from rpc tenants.v1.UserService.UpdateUserStatus
   */
  updateUserStatus: {
    methodKind: "unary";
    input: typeof UpdateUserStatusRequestSchema;
    output: typeof UpdateUserStatusResponseSchema;
  },
  /**
   * DeleteUser permanently deletes an already-disabled user account: a
   * soft-delete in Sunstone, paired with a hard-delete of their Auth0
   * identity. Rejects a target that isn't already DISABLED, the caller's
   * own account, or a tenant's last remaining Admin.
   *
   * @generated from rpc tenants.v1.UserService.DeleteUser
   */
  deleteUser: {
    methodKind: "unary";
    input: typeof DeleteUserRequestSchema;
    output: typeof DeleteUserResponseSchema;
  },
  /**
   * UpdateUserAccess performs one or more of: renaming the user, changing
   * their primary role, creating access_rules, and revoking access_rules —
   * all in a single transaction, recorded as one audit event. Admin/
   * Operator Admin only.
   *
   * @generated from rpc tenants.v1.UserService.UpdateUserAccess
   */
  updateUserAccess: {
    methodKind: "unary";
    input: typeof UpdateUserAccessRequestSchema;
    output: typeof UpdateUserAccessResponseSchema;
  },
  /**
   * ListAccessRules returns every access_rules row for one user, for the
   * member-detail view.
   *
   * @generated from rpc tenants.v1.UserService.ListAccessRules
   */
  listAccessRules: {
    methodKind: "unary";
    input: typeof ListAccessRulesRequestSchema;
    output: typeof ListAccessRulesResponseSchema;
  },
  /**
   * PreviewAccessRuleMatch evaluates a candidate restriction against the
   * tenant's current resources, for the restriction builder's live-preview
   * panel. Admin/Operator Admin only (same callers as UpdateUserAccess/
   * CreateInvitation's restriction builder).
   *
   * @generated from rpc tenants.v1.UserService.PreviewAccessRuleMatch
   */
  previewAccessRuleMatch: {
    methodKind: "unary";
    input: typeof PreviewAccessRuleMatchRequestSchema;
    output: typeof PreviewAccessRuleMatchResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tenants_v1_tenants, 1);

/**
 * RoleService manages roles: the one seeded System role (Admin), Platform
 * roles (custom, tenant-less, visible only in the platform context), and
 * each tenant's own Tenant roles.
 *
 * @generated from service tenants.v1.RoleService
 */
export const RoleService: GenService<{
  /**
   * GetRole fetches one role by ID, for the role detail view.
   *
   * @generated from rpc tenants.v1.RoleService.GetRole
   */
  getRole: {
    methodKind: "unary";
    input: typeof GetRoleRequestSchema;
    output: typeof GetRoleResponseSchema;
  },
  /**
   * ListRoles returns the roles visible to a tenant (or, with an empty
   * tenant_id, the platform-context view — Admin plus every Platform role).
   *
   * @generated from rpc tenants.v1.RoleService.ListRoles
   */
  listRoles: {
    methodKind: "unary";
    input: typeof ListRolesRequestSchema;
    output: typeof ListRolesResponseSchema;
  },
  /**
   * CreateRole creates a tenant-scoped Tenant role, or (with an empty
   * tenant_id) a Platform role, optionally with its own initial
   * access_rules. See CreateRoleRequest.
   *
   * @generated from rpc tenants.v1.RoleService.CreateRole
   */
  createRole: {
    methodKind: "unary";
    input: typeof CreateRoleRequestSchema;
    output: typeof CreateRoleResponseSchema;
  },
  /**
   * UpdateRole edits an existing non-grants_all role's name/description/
   * permissions, and optionally its own access_rules, all in one request/
   * transaction/audit event. See UpdateRoleRequest.
   *
   * @generated from rpc tenants.v1.RoleService.UpdateRole
   */
  updateRole: {
    methodKind: "unary";
    input: typeof UpdateRoleRequestSchema;
    output: typeof UpdateRoleResponseSchema;
  },
  /**
   * ListRoleAccessRules returns every access_rules row owned by one role.
   *
   * @generated from rpc tenants.v1.RoleService.ListRoleAccessRules
   */
  listRoleAccessRules: {
    methodKind: "unary";
    input: typeof ListRoleAccessRulesRequestSchema;
    output: typeof ListRoleAccessRulesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tenants_v1_tenants, 2);

